<template>
<div class="chapter">
<div class="inner_page">
<p class="label1"><a id="pt1"></a><a id="page_17"></a><strong>I</strong></p>
<p class="h2a"><strong>Advancing Economic and Financial Measurement Practice: Lessons from the Financial Crisis</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226204437_09_pt1.vue?78b9730c